@if(!isDialogOpen() && isTransferFundsLoading())
{
<mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
@else{
<div class="transfer-funds-container"
     [class.fullscreen-mode]="!isDialogOpen()">
    <div mat-dialog-title class="title">
        <span class="heading">Transfer Request</span>
        @if(isDialogOpen())
        {
        <div class="title-actions">
            <button type="button" mat-icon-button (click)="openInNewTab()" class="new-tab">
                <mat-icon>open_in_new</mat-icon>
            </button>

            <button type="button" mat-dialog-close mat-icon-button (click)="closeDialog()">
                <mat-icon class="close-icon-color">cancel</mat-icon>
            </button>
        </div>
        }
    </div>
    <div #dialogContent mat-dialog-content>
        <form [formGroup]="transferFundRequestForm">
            <div class="header-content">
                @if (showReturnReason) {
                <mat-form-field class="fullLength">
                    <mat-label style="color: red;">Rejected Reason</mat-label>
                    <input matInput formControlName="returnReason" readonly>
                </mat-form-field>
                }
                <mat-form-field>
                    <mat-label>Matter</mat-label>
                    <input readonly matInput formControlName="matterName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Client</mat-label>
                    <input readonly matInput formControlName="client" />
                </mat-form-field>

                @if (isDateTransactionVisible) {
                <div class="date-time-row">
                    <mat-form-field color="accent" class="date-field">
                        <mat-label>Transaction Date</mat-label>
                        <input matInput
                               [matDatepicker]="dateTransactionPicker"
                               formControlName="dateTransaction"
                               placeholder="dd/MM/yyyy"  [max]="currentDate"/>
                        <mat-datepicker-toggle matSuffix [for]="dateTransactionPicker" />
                        <mat-datepicker #dateTransactionPicker />
                        @if (transferFundRequestForm.get('dateTransaction')?.touched &&
                        transferFundRequestForm.get('dateTransaction')?.invalid) {
                        <mat-error>Please select a date.</mat-error>
                        }
                    </mat-form-field>

                    <mat-form-field color="accent" class="time-field">
                        <mat-label>Transaction Time</mat-label>
                        <input matInput
                               type="time"
                               formControlName="transactionTime" />
                    </mat-form-field>
                </div>
                }

                @if (showLinkToOpenMatter()) {
                <div class="sticky-actionstep-bar">
                    <div class="link-wrapper">
                        <a [href]="actionstepMatterUrl"
                           target="_blank"
                           rel="noopener noreferrer">
                            Open Matter in Actionstep ({{ matterNo }})
                        </a>
                        <button mat-icon-button
                                class="small-copy-btn"
                                [cdkCopyToClipboard]="actionstepMatterUrl"
                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                matTooltip="Copy link to clipboard"
                                matTooltipPosition="below">
                            <mat-icon>content_copy</mat-icon>
                        </button>
                    </div>
                    <div class="warning-box">
                        You must be logged into Actionstep under the same jurisdiction.
                    </div>
                </div>
                }
            </div>

            <mat-tab-group class="request-tab" color="accent" [animationDuration]="'0ms'" [disableRipple]="true">
                <mat-tab label="Request Details">
                    <div [ngClass]="{
                            'tab-content-wrapper-return': isDialogOpen() && showReturnReason,
                            'tab-content-wrapper': isDialogOpen() && !showReturnReason,
                            'extended-tab-content-return-wrapper': !isDialogOpen() && showReturnReason,
                            'extended-tab-content-wrapper': !isDialogOpen() && !showReturnReason
                          }">
                        <div class="scroll-liner">
                            <div class="form-content">
                                <mat-form-field>
                                    <mat-label>Reason for Transfer</mat-label>
                                    <input matInput formControlName="reason" [readonly]="!canEditFields" (input)="onReasonInput()" />
                                    <mat-error>Please enter a valid reason for transfer.</mat-error>
                                </mat-form-field>
                                <mat-form-field>
                                    <mat-label>Amount</mat-label>
                                    <input readonly matInput formControlName="amount" appCurrencyInput/>
                                </mat-form-field>

                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Client Bank</mat-label>
                                    <mat-select formControlName="clientBankAccount" required>
                                        @for (account of filteredBankAccounts; track account.accountId) {
                                        <mat-option [value]="account">
                                            {{ account.accountId }} -
                                            {{ account.description }}
                                        </mat-option>
                                        }
                                    </mat-select>
                                    @if (transferFundRequestForm.get('clientBankAccount')?.hasError('required')) {
                                    <mat-error>Please select a bank account.</mat-error>
                                    }
                                </mat-form-field>

                                @if (showLinkToOpenMatter()) {
                                <div class="actionstep-matter-overview">
                                    <div class="link-wrapper">
                                        <a [href]="actionstepMatterOverviewUrl"
                                           target="_blank"
                                           rel="noopener noreferrer">
                                            Open Actionstep Matter ({{ matterNo }}) Overview
                                        </a>
                                        <button type="button" mat-icon-button
                                                class="small-copy-btn"
                                                [cdkCopyToClipboard]="actionstepMatterOverviewUrl"
                                                (cdkCopyToClipboardCopied)="onUrlCopied()"
                                                matTooltip="Copy link to clipboard"
                                                matTooltipPosition="below">
                                            <mat-icon>content_copy</mat-icon>
                                        </button>
                                    </div>
                                    <div class="warning-box">
                                        You must be logged into Actionstep under the same jurisdiction.
                                    </div>
                                </div>
                                }


                                @if (showAccountFields) {
                                <mat-form-field class="halfLength">
                                    <mat-label>Payment method</mat-label>
                                    <mat-select formControlName="paymentMethod">
                                        @for (method of paymentMethodDropdown; track method) {
                                        <mat-option [value]="method">{{method}}</mat-option>
                                        }
                                    </mat-select>
                                </mat-form-field>
                                }

                                @if (showAccountFields) {
                                <mat-form-field class="halfLength">
                                    <mat-label>Transaction reference</mat-label>
                                    <input matInput formControlName="transactionReference">
                                    @if (transferFundRequestForm.get('transactionReference')?.touched && transferFundRequestForm.get('transactionReference')?.hasError('required')) {
                                    <mat-error>Please enter transaction reference.</mat-error>
                                    }
                                </mat-form-field>
                                }

                                @if (showAccountFields) {
                                <mat-form-field class="halfLength">
                                    <mat-label>Deposit Account</mat-label>
                                    <mat-select formControlName="depositAccount">
                                        @for (account of depositAccounts; track account.accountNumber) {
                                        <mat-option [value]="account.accountNumber">
                                            {{ account.accountNumber }} - {{ account.name }} ({{ account.currency }})
                                        </mat-option>
                                        }
                                    </mat-select>
                                    @if (transferFundRequestForm.get('depositAccount')?.touched && transferFundRequestForm.get('depositAccount')?.hasError('required')) {
                                    <mat-error>Please select deposit account.</mat-error>
                                    }
                                </mat-form-field>
                                }

                                <mat-form-field>
                                    <mat-label>Partner authorising</mat-label>
                                    <input readonly matInput formControlName="partnerAuthorising" />
                                </mat-form-field>

                                <div class="date-time-row">
                                    <mat-form-field color="accent" class="date-field">
                                        <mat-label>Requested Date</mat-label>
                                        <input matInput
                                               [matDatepicker]="dateRequestedPicker"
                                               formControlName="dateRequested"
                                               placeholder="dd/MM/yyyy" />
                                        <mat-datepicker-toggle matSuffix [for]="dateRequestedPicker" />
                                        <mat-datepicker #dateRequestedPicker />
                                    </mat-form-field>

                                    <mat-form-field color="accent" class="time-field">
                                        <mat-label>Requested Time</mat-label>
                                        <input matInput
                                               type="time"
                                               formControlName="requestedTime" />
                                    </mat-form-field>
                                </div>

                                @if (transferFundRequestForm.get('dateAuthorized')?.value) {
                                <mat-form-field color="accent">
                                    <mat-label>Date authorised</mat-label>
                                    <input matInput
                                           [matDatepicker]="pickerDateAuth"
                                           placeholder="Date authorised"
                                           formControlName="dateAuthorized"
                                           readonly />
                                    <mat-datepicker-toggle matSuffix color="mat-accent"
                                                           [for]="pickerDateAuth"></mat-datepicker-toggle>
                                    <mat-datepicker #pickerDateAuth></mat-datepicker>
                                </mat-form-field>
                                }

                                @if (bills.length > 0){
                                <mat-table [dataSource]="bills" class="fullLength">
                                    <ng-container matColumnDef="pay">
                                        <mat-header-cell *matHeaderCellDef> Action Step Balance </mat-header-cell>
                                        <mat-cell *matCellDef="let bill">
                                            Invoice #{{ bill.ourReference }}
                                            (Balance Due: {{ currencySymbol }}{{ bill.totalDue }})
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="warning">
                                        <mat-header-cell *matHeaderCellDef> Eligible Payment Amount </mat-header-cell>
                                        <mat-cell *matCellDef="let bill">
                                            @if (invoiceMap[bill.ourReference]; as invoiceData) {
                                            <ng-container>
                                                <div class="warning-box">
                                                    Current Balance for Invoice #{{ bill.ourReference }} is
                                                    ({{ currencySymbol }}{{ (bill.totalDue - invoiceData.totalAmount) | number:'1.2-2' }})
                                                </div>
                                            </ng-container>
                                            }
                                        </mat-cell>
                                    </ng-container>

                                    <ng-container matColumnDef="amount">
                                        <mat-header-cell *matHeaderCellDef> Amount </mat-header-cell>
                                        <mat-cell *matCellDef="let bill" class="amount-cell">
                                            <mat-form-field class="amountField">
                                                <input type="text" matInput [formControlName]="getControlName(bill)"
                                                       (keydown)="validateInput($event)" appCurrencyInput>
                                                <mat-error *ngIf="transferFundRequestForm.get(getControlName(bill))?.hasError('max')">
                                                    The entered amount exceeds the total due amount.
                                                </mat-error>
                                            </mat-form-field>
                                        </mat-cell>
                                    </ng-container>

                                    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                                    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                                </mat-table>
                                }

                                @if (bills.length > 0) {
                                <div class="amount-row">
                                    <div class="total-amout">Total Amount</div>
                                    <mat-form-field class="amout">
                                        <input type="text" matInput maxlength="12" formControlName="amount" appCurrencyInput />
                                    </mat-form-field>
                                </div>
                                }
                                @if (noBillsFoundMessage) {
                                <div class="no-bills-message">{{ noBillsFoundMessage }}</div>
                                }
                            </div>
                            <div class="form-content">
                                @if (transferFundData.comments?.length) {
                                @for (item of transferFundData.comments; let i = $index; track i) {
                                <mat-form-field>
                                    <mat-label>
                                        {{ i + 1 }}. {{ StagesLabel[item.stageId ?? item.currentStageId!] }}
                                    </mat-label>
                                    <textarea matInput [value]="item.comment" readonly></textarea>
                                </mat-form-field>
                                }
                                }

                                @if (!disableButtons) {
                                <mat-form-field class="fullLength">
                                    <mat-label>Add Comments/Notes</mat-label>
                                    <textarea matInput formControlName="comments"></textarea>
                                </mat-form-field>
                                }
                            </div>

                            @if (showFundsCheckedByPartner) {
                            <mat-checkbox class="fullLength" formControlName="fundsCheckedByPartner">
                                I confirm that available funds have been checked.<span class="important">*</span>
                            </mat-checkbox>
                            }

                            @if (FundsCheckedPartnerText) {
                            <mat-checkbox class="fullLength"
                                          formControlName="fundsCheckedByPartner">
                                Available funds have been checked by partner.
                            </mat-checkbox>
                            }

                            @if(isAmountReleased)
                            {
                            <mat-checkbox class="fullLength" formControlName="isCheckedLedger">I have confirmed that I have checked the ledger for available funds.<span class="important">*</span></mat-checkbox>
                            }

                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Audit">
                    <xp-audit-log [ngClass]="{
                            'dialog-mode-rejected': isDialogOpen() && showReturnReason,
                            'dialog-mode': isDialogOpen() && !showReturnReason,
                            'extended-transfer-funds-mode-rejected': !isDialogOpen() && showReturnReason,
                            'extended-transfer-funds-mode': !isDialogOpen() && !showReturnReason
                                      }" [requestId]="getRequestId" [requestType]="RequestType.TransferFund" [showPaginator]="false" />
                </mat-tab>
            </mat-tab-group>
        </form>
    </div>
    <div mat-dialog-actions class="action-buttons" [class.right-buttons]="!isDialogOpen()">
        <button [disabled]="disableButtons || transferFundRequestForm.invalid" (click)="approveRequest()" mat-raised-button color="accent">
            {{approveBtn}}
        </button>

        @if(previousStages.length == 0)
        {
        <button type="button" [disabled]="disableButtons" (click)="delete()" mat-raised-button color="warn">
            Reject
        </button>
        }

        @if(previousStages.length > 0)
        {
        <button type="button" [disabled]="disableButtons" mat-raised-button [matMenuTriggerFor]="rejectMenu" color="warn">
            Reject
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        }

        <mat-menu #rejectMenu="matMenu">
            @for (previousStage of previousStages; track previousStage.stageOrder) {
            <span [matTooltip]="isReturnDisabled(previousStage.stageOrder) ? 'This request must be returned to the Accounts team for reversal.' : ''"
                  matTooltipPosition="right"
                  matTooltipShowDelay="300">
                <button type="button" mat-menu-item
                        [disabled]="isReturnDisabled(previousStage.stageOrder)"
                        (click)="returnRequest(previousStage.stageOrder, previousStage.rejectStatus || 'Return')">
                    {{ previousStage.rejectStatus }}
                </button>
            </span>
            }
            <mat-divider></mat-divider>
            <button type="button" mat-menu-item [disabled]="accountsStage" (click)="delete()">Reject</button>
        </mat-menu>
    </div>
</div>
}
